import { TApplicationState, TAsyncThunkStatus } from 'shared/mf-infrastructure/types/redux';

export function selectInfrastructureStatus(state: TApplicationState): TAsyncThunkStatus {
  return state.infrastructure.status;
}
